

// TEST SERVICE-API URL
// export const HOSTNAME = 'http://localhost:8081';


// TEST LDA URL
// export const LargeDataAnalyticsHostname = 'http://localhost:8080';

// PRODUCTION URLS
export const HOSTNAME = 'https://r-1-12-2025-v2---service-api-d6vxitfn5a-uc.a.run.app';
export const LargeDataAnalyticsHostname = 'https://r-12-31-2024---large-data-analytics-d6vxitfn5a-uc.a.run.app';


export const GoogleCloudStorageBucketUrl = 'https://storage.googleapis.com/users-webapp-platform-storage/';



export const UPLOAD_URL = `${HOSTNAME}/files/editor/upload`;
export const FETCH_RESOURCE_URL = `${HOSTNAME}/files/serve`;


export const AdvyzonRedirectUrl = 'https://main.yhlsoft.com/auth/users/sign_in?scope=auth&is_timeout=0&redirect_uri=https%3A%2F%2Fmain.yhlsoft.com%2Fhome%2Fv2%2Fstrategist_portal%3Fbranch_id%3D88888888-8888-8888-8888-888888888888%26prod%3DMMP%23%2FmodelPending'